// a slimmer version of the httpService that uses the api wrapper in api.ts, will have to wait a bit before we use this as this file contains almost 70 functions that
import { User } from "../models/Models";

import { IHttpAnswer } from "../interfaces/httpAnswer";
import * as versionFile from "../version.json";

import api from "../api";

const API_URL = process.env.REACT_APP_API_URL;

async function login(mobile: string): Promise<IHttpAnswer<User>> {
  const version = `${versionFile.major}.${versionFile.minor}`;
  const loginRequest = {
    phoneNumber: mobile,
    version: version,
  };
  const response = await fetch(`${API_URL}/Authentication/GetUserAccess`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(loginRequest),
  });
  if (response.ok) {
    const data = await response.json();
    return { data: data, isOk: response.ok, statusCode: response.status };
  }
  const data = await response.json();
  return { data: data, isOk: response.ok, statusCode: response.status };
}

async function logout(): Promise<IHttpAnswer<boolean>> {
  const response = await api.post(
    `/Authentication/InvalidateCurrentSession`,
    null
  );
  return { data: true, isOk: response.isOk, statusCode: response.statusCode };
}

export { login, logout };
